module.exports = {

    search : function search(text, regex, casse)
    {
        if (casse == false)
            var regex_option = "gi";
        else
            var regex_option = "g"
        regex = RegExp(regex, regex_option)
        var result = [];
        var r;
        var last_index = -1;

        while (r = regex.exec(text))
        {
            if (last_index == regex.lastIndex)
                break;
            result.push(r);
            last_index = regex.lastIndex;
        }

        return result;
    },


    standardize_json_all(data)
    {
        var columns = [];
        var difference = false;

        for (var j = 0; j < data.length; j++)
        {
            let column_keys = [];
            if (data.length > 0)
                column_keys = Object.keys(data[j]);
            if (column_keys.length > 10000)
                return data;
            if (!_.isEqual(columns, column_keys))
            {
                if (j != 0)
                    difference = true;
                columns =  _.union(columns, column_keys);
            }
        }

        if (difference)
        {
            var column_keys = [];
            for (var j = 0; j < data.length; j++)
            {
                column_keys = Object.keys(data[j]);
                let diff = columns.filter(x => !column_keys.includes(x));
                for (var k = 0; k < diff.length; k++)
                {
                    data[j][diff[k]] = "";
                }
            }     
        }

        return data;
    }

}